<div class="container-fluid p-0">
  <div class="tab-description">
    Create and manage groups of questions to organize and control question visibility.
  </div>
  <!-- Action Bar -->
  <div class="d-flex justify-content-between align-items-center mb-4">
    <!-- New Button -->
    <button class="create-group-btn" [disabled]="loading || !isUserHasWriteAccess" (click)="openGroupModal()" title="Create a new group">
      Create New Group
    </button>

    <!-- Search Box -->
    <div class="search-group-box position-relative">
      <span class="search-group-icon"><img src="./assets/images/search-icon.svg"></span>
      <input 
        type="text" 
        class="search-group-input" 
        placeholder="Search a question" 
        [(ngModel)]="searchText"
        [disabled]="!groupsAvailable || groupsAvailable.length === 0">
    </div>
  </div>
   
  <!-- Loading State -->
  <div class="text-center py-5" *ngIf="loading">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-2">Loading groups...</p>
  </div>
  
  <!-- Empty State -->
  <div class="empty-state" *ngIf="!loading && (!groupsAvailable || filteredGroups.length === 0)">
    <div class="error-message">
      No Interaction or Visibility groups created. To create a group click on the "New" button.
    </div>
  </div>
  
  <!-- Groups Table -->
  <div class="card groups-card" *ngIf="!loading && filteredGroups && filteredGroups.length > 0">
    <div class="card-body p-0">
      <!-- Table Header -->
      <div class="group-header d-flex">
        <div class="group-name-header table-text">Group Name</div>
        <div class="group-type-header table-text">Type</div>
        <div class="group-actions-header table-text">Actions</div>
      </div>
      
      <!-- Table Rows -->
      <div class="group-row d-flex" *ngFor="let group of filteredGroups">
        <div class="group-name">{{ group.name }}</div>
        <div class="group-type">{{ getGroupTypeLabel(group.groupType) }}</div>
        <div class="group-actions">
          <button class="btn action-btn" 
                  (click)="openGroupModal(group.id, group.groupType)"
                  title="Edit this group">
             <svg class="device-icon">
            <use [attr.xlink:href]="'./assets/images/icons.svg#editIcon'"></use>
          </svg>
          </button>
           
          <button class="btn action-btn" 
                  [disabled]="!isUserHasWriteAccess"
                  (click)="removeGroup(group.id, group.groupType)"
                  title="Delete this group">
              <svg class="icon-set">
            <use [attr.xlink:href]="'./assets/images/icons.svg#trash-can-outline'"></use>
          </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>





<!-- Group Edit Side Panel -->
<div class="group-side-panel" *ngIf="showGroupModal">
  <div class="side-panel-overlay" (click)="dismissModal()"></div>
  <div class="side-panel-container">
    <div class="side-panel-header">
      <div class="header-label">{{ isEditing ? 'Edit Group Question' : 'Group Question' }}</div>
      <div class="header-actions">
        <button class="close-button" (click)="dismissModal()">
          <img src="./assets/images/close.svg">
        </button>
      </div>
    </div>
    
    <div class="side-panel-content">
      <div class="group-editor-container">
        <!-- Left side - Group editor -->
        <div class="group-editor">
          <div class="page-edit-form">
            <form [formGroup]="groupForm">
              <!-- Group Name -->
              <div class="editor-row">
                <div class="input-group">
                  <label for="groupName">Name</label>
                  <div class="input-wrapper">
                    <input 
                      type="text" 
                      class="form-control" 
                      id="groupName" 
                      [attr.disabled]="!isUserHasWriteAccess"
                      [attr.readonly]="!isUserHasWriteAccess"
                      [disabled]="!isUserHasWriteAccess"
                      formControlName="name"
                      (keyup)="checkSameGroupExist()"
                      placeholder="Enter group name..."
                      [ngClass]="{'is-invalid': groupForm.get('name')?.invalid && groupForm.get('name')?.touched}">
                  </div>
                  <div class="invalid-feedback" *ngIf="groupForm.get('name')?.errors?.['required']">
                    Group name is required
                  </div>
                  <div class="invalid-feedback" *ngIf="groupForm.get('name')?.errors?.['minlength']">
                    Group name must be at least 3 characters
                  </div>
                  <div class="invalid-feedback" *ngIf="groupForm.get('name')?.errors?.['groupExists']">
                    A group with this name already exists
                  </div>
                </div>
              </div>
      
              <!-- Group Type -->
             <div class="editor-row">
                <div class="input-group">
                  <label for="groupType">Type</label>
                  <div class="select-wrapper custom-select-wrapper">
                    <select
                      class="form-select custom-select"
                      id="groupType"
                      formControlName="groupType"
                      [attr.disabled]="isGroupSelectionDisabled || !isUserHasWriteAccess"
                      (change)="resetFieldsOnToggleGroup()">
                      <option value="question_group" class="text-font">Interaction Group</option>
                      <option value="access_group" class="text-font">Visibility Group</option>
                    </select>
                    <img src="./assets/images/new-arrow.svg" class="custom-arrow" />
                  </div>
                  <small class="text-muted" *ngIf="isGroupSelectionDisabled">
                    Group type cannot be changed after creation
                  </small>
                </div>
              </div>

              <!-- Fields Selection -->
              <div class="editor-row">
                <div class="input-group">
                  <label class="form-label">Field</label>
                  <div class="fields-container">
                    <div class="field-item" *ngFor="let field of fields">
                      <div class="form-check" *ngIf="filterFieldsOnGroupToggle(field)">
                        <input 
                          class="form-check-input" 
                          type="checkbox" 
                          [id]="field.field_id"
                          [disabled]="!isUserHasWriteAccess"
                          [checked]="isFieldAvailable(field.field_id)"
                          (change)="toggleField(field, $event)">
                        <label class="form-check-label" [for]="field.field_id">
                          {{ field.text }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    
    <div class="side-panel-footer">
      <button class="btn-cancel" (click)="dismissModal()">Cancel</button>
      <button 
        class="btn-save" 
        (click)="saveGroup($event)"
        [disabled]="groupForm.get('name')?.value === '' || groupForm.get('name')?.errors?.['groupExists'] || groupForm.get('fields')?.value?.length === 0 || !isUserHasWriteAccess">
        {{ isEditing ? 'Save Changes' : 'Create Group' }}
      </button>
    </div>
  </div>
</div>

